import {useAppStore, useUserStore} from '@/stores'
import {useLocalStream} from '@/composables'
import {mediator, messenger} from '@communication'
import {procedures} from '@communication'
export default class DestroyProcedure {
  constructor() {
    this.name = 'destroyProcedure'
  }

  install = () => {
    messenger.subscribe(this.name, 'session:participant:disjoined', this.checkAssistantDestroy)
  }

  uninstall = () => {}

  destroy = async () => {
    // todo: add flag isDestroying...
    const app = useAppStore()
    const user = useUserStore()
    const {stream} = useLocalStream()
    // A failed save must not skip the disjoin below, or the others are never told the session ended
    try {
      if (app.state.matches('app.recording.on') && user.party === 'assistant') {
        await procedures.get('recordingProcedure').stop()
      }
    } catch (error) {
      console.error('[destroy] stopping the recording before disjoin failed', error)
    }
    try {
      if (app.state.matches('app.view.meeting.draw')) {
        await messenger.emit('board:signal', 'snapshot:save')
        await procedures.get('snapshotProcedure').dismiss('snapshot')
      }
    } catch (error) {
      console.error('[destroy] saving the snapshot before disjoin failed', error)
    }
    app.transition('HIDE_PARTICIPANTS_MODAL')
    app.transition('HIDE_CONNECTION_STATUS_MODAL')
    app.loading()
    await mediator.destroy()
    user.disjoin()
    stream.video.stop()
    stream.audio.stop()
    app.transition('exit')
    // todo: specify exit transition
    setTimeout(() => {
      app.loaded()
    }, 2000)
  }

  checkAssistantDestroy = event => {
    const {party, isAlreadyDisJoined} = event
    if (party === 'assistant' && isAlreadyDisJoined) {
      this.destroy()
    }
  }

  silentlyDestroy = async () => {
    // todo: add flag isDestroying...
    const app = useAppStore()
    const user = useUserStore()
    const {stream} = useLocalStream()
    if (app.state.matches('app.recording.on') && user.party === 'assistant') {
      procedures.get('recordingProcedure').stop()
    }
    await mediator.destroy()
    user.disjoin()
    stream.video.stop()
    stream.audio.stop()
  }
}
